import "../../assets/css/usecases.css";
import sygeplejerskerImage from "../../assets/people/sygeplejerske.jpg";
import medicinstuderendeImage from "../../assets/people/medicinstuderende.jpg";
import laegerImage from "../../assets/people/speciallæge-cropped.png";
import laegeImage from "../../assets/people/læge.jpg";

export default function UseCases() {
  return (
    <div className="container bg-white mx-auto pb-20 pt-20 md:pb-24 mt-0 md:pt-32">
      <div>
        <div>
          <dl className="grid mx-auto grid-cols-1 gap-x-[3rem] lg:max-w-none lg:grid-cols-2">
            <div className="relative mb-20 md:mb-24 flex flex-col md:flex-row">
              <dt className="font-semibold text-gray-900">
                <div className="md:h-[200px] md:w-[165px] rounded-2xl">
                  <img
                    src={laegerImage}
                    alt="speciallæger"
                    className="object-cover speciallaeger shadow-md rounded-2xl h-full w-full"
                  />
                </div>
              </dt>

              <dd className="md:pl-12">
                <h4 className="font-bold mb-2 text-doctio-green text-dlg mt-8 md:mt-0">
                  Speciallæger
                </h4>

                <p className="my-0 font-medium">
                  Opret dine egne fraser, benyt vores store frasebibliotek og
                  ret fraserne til så de passer dig. Spar tid med DoctioAssist
                  der hurtigt og nemt indsætter tekst og fraser. uanset hvilket
                  journalsystem du bruger. Del fraser med klinikpersonale eller
                  andre klinikker og vær fælles om at holde delte fraser
                  ajourførte.
                </p>
              </dd>
            </div>
            <div className="relative mb-20 md:mb-24 flex flex-col md:flex-row">
              <dt className=" font-semibold text-gray-900">
                <div className="md:h-[200px] md:w-[165px] rounded-2xl">
                  <img
                    src={laegeImage}
                    alt="Læge billede"
                    className="object-cover laege-billede shadow-md rounded-2xl h-full w-full md:mr-12"
                  />
                </div>
              </dt>
              <dd className="md:pl-12">
                <h4 className="font-bold mb-2 laege-billede text-doctio-green text-dlg mt-8 md:mt-0">
                  Læger
                </h4>

                <p className="my-0 font-medium">
                  Doctio tilbyder dynamiske fraser med algoritmer fra
                  forskellige behandlingsvejledninger. En helt ny
                  revolutionerende måde at journalføre på. Via klikelementer
                  “lytter” fraserne på de valg der indtastes, og kan automatisk
                  udfylde felter eller give forslag til behandlingsplaner.
                </p>
              </dd>
            </div>
            <div className="relative mb-20 md:mb-24 flex flex-col md:flex-row">
              <dt className=" font-semibold text-gray-900">
                <div className="md:h-[200px] md:w-[165px] rounded-2xl">
                  <img
                    src={sygeplejerskerImage}
                    alt="Sygeplejersker"
                    className="object-cover sygeplejerske-billede shadow-md rounded-2xl h-full w-full md:mr-12"
                  />
                </div>
              </dt>
              <dd className="md:pl-12">
                <h4 className="font-bold mb-2 text-doctio-green text-dlg mt-8 md:mt-0">
                  Sygeplejersker
                </h4>

                <p className="my-0 font-medium">
                  Ved at nedbringe tidsforbruget på journalføring frigiver det
                  tid til dine kerneopgaver. Fraser, klik-fraser og DoctioAssist
                  kan give mere tid i en travl hverdag. Som
                  konsultationssygeplejerske kan fraser også fungere som et
                  understøttende beslutningsværktøj.
                </p>
              </dd>
            </div>
            <div className="relative mb-20 md:mb-24 flex flex-col md:flex-row">
              <dt className="font-semibold text-gray-900">
                <div className="md:h-[200px] md:w-[165px] rounded-2xl">
                  <img
                    src={medicinstuderendeImage}
                    alt="medicinstuderende"
                    className="object-cover md-billede shadow-md rounded-2xl h-full w-full md:mr-12"
                  />
                </div>
              </dt>
              <dd className="md:pl-12">
                <h4 className="font-bold mb-2 text-doctio-green text-dlg mt-8 md:mt-0">
                  Medicinstuderende
                </h4>
                <p className="my-0 font-medium">
                  Fraser kan anvendes som et effektivt læringsredskab i
                  klinikken. Fraser hjælper til at huske at spørge til og
                  undesøge for klinisk relevante elementer i anamnesen og den
                  objektive undersøgelse. Informationsbokse, billeder og videoer
                  forklarer hurtigt fagtermer, undersøgelser, behandlingsplaner
                  etc.
                </p>
              </dd>
            </div>
          </dl>
          <div className="flex items-center justify-center h-full">
            <button
              type="button"
              className="text-white transition-colors duration-300 ease-in-out font-bold w-52 rounded-full bg-doctio-green focus:outline-none  hover:bg-white hover:text-doctio-green hover:shadow-md px-2 py-2 text-center mr-0 md:md:mr-12"
            >
              Prøv gratis
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
